import { Input, Directive, SimpleChanges, HostBinding, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

import { VbBaseMenuComponent } from './VbBaseMenu.Component';

@Directive({
	selector: 'vb-nested-selection-menu',
    standalone: false
})
export class VbNestedMenuComponent extends VbBaseMenuComponent {
	@Input() public parentElement: ElementRef;
	@Input() public activateDropdown: boolean;

	@HostBinding('hidden')
	public get keepHidden() {
		return !this.activateDropdown;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.activateDropdown && this.activateDropdown) {
			this.dropdown.show();
		}
	}

	/**
	 * workaround of outside click.
	 * currently nested menu not fully supported by ngx-bootstrap.
	 */
	@HostListener('document:click', ['$event'])
	public onDocumentClick(event: MouseEvent): void {
		if (this.parentElement.nativeElement.contains(event.target)) {
			return;
		}

		if (this.dropdown?.isOpen) {
			this.hideMenu(true);
		}
	}
}
